module.exports = __webpack_public_path__ + "static/img/chuli.83bcb35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/chuli.jpg
// module id = T0UZ
// module chunks = 5